import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=2a64dac8&scoped=true"
import script from "./Dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropdown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Dropdown.vue?vue&type=style&index=0&id=2a64dac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64dac8",
  null
  
)

export default component.exports